import { get } from 'lodash';
import * as Constants from '../../constants';

const resetState = {
  isError: false,
  errors: [],
  isUpdateSuccessful: false,
  isUpdateError: false,
  updateErrorMsg: '',
  isFormLoadingError: false,
};

const initialState = {
  ...resetState,
  isLoading: false,
};

const getValidationErrorMessage = (payload) => get(payload, 'error.detail.devErrorMessage');

export default function (state = initialState, action) {
  switch (action.type) {
    case Constants.APP_RESET:
      return {
        ...state,
        ...resetState,
      };
    case Constants.REGISTRATION_SETTINGS_GET_REQUEST:
      return {
        ...state,
        ...resetState,
        isLoading: true,
      };
    case Constants.REGISTRATION_SETTINGS_UPDATE_REQUEST:
      return {
        ...state,
        ...resetState,
        isLoading: true,
      };
    case Constants.REGISTRATION_SETTINGS_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        data: action.payload,
      };
    case Constants.REGISTRATION_SETTINGS_GET_ERROR:
      return {
        ...state,
        isLoading: false,
        isFormLoadingError: true,
        isError: true,
        errors: action.payload,
      };
    case Constants.REGISTRATION_SETTINGS_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isUpdateSuccessful: true,
        data: action.payload,
      };
    case Constants.REGISTRATION_SETTINGS_UPDATE_ERROR: {
      const updateErrorMsg = getValidationErrorMessage(action.payload);
      return {
        ...state,
        isUpdateError: true,
        isLoading: false,
        ...(updateErrorMsg ? { updateErrorMsg } : {}),
      };
    }
    default:
      return state;
  }
}

export const getRegistrationSettings = (state) => get(state, 'registrationSettings.data');
export const getIsLoading = (state) => get(state, 'registrationSettings.isLoading');
export const getIsError = (state) => get(state, 'registrationSettings.isError');
export const getErrors = state => get(state, 'registrationSettings.errors');
export const getIsFormLoadingError = (state) => get(state, 'registrationSettings.isFormLoadingError');
export const getIsFormUpdateError = (state) => get(state, 'registrationSettings.isUpdateError');
export const getIsUpdateSuccessful = (state) => get(state, 'registrationSettings.isUpdateSuccessful');
export const getUpdateErrorMsg = (state) => get(state, 'registrationSettings.updateErrorMsg');
